import React from 'react';
import { FadeIn } from './FadeIn';
import { Clock, Briefcase, Zap, FileText } from 'lucide-react';
export function ProductPresentation() {
  const benefits = [{
    icon: <Clock className="w-6 h-6 text-brand-green" strokeWidth={1.75} data-id="element-114" />,
    title: 'Lo que antes eran 40 minutos, ahora son 5',
    desc: 'Cada plantilla está pensada para completar solo los datos variables del paciente. El resto ya está hecho.'
  }, {
    icon: <Briefcase className="w-6 h-6 text-brand-green" strokeWidth={1.75} data-id="element-115" />,
    title: 'Imagen profesional desde el día uno',
    desc: 'Documentos con estructura clínica real que generan confianza inmediata en las familias y en las obras sociales.'
  }, {
    icon: <Zap className="w-6 h-6 text-brand-green" strokeWidth={1.75} data-id="element-116" />,
    title: 'Descargás y usás hoy',
    desc: 'Sin configurar nada. Sin cursos. Sin esperar. Editás con tu nombre y empezás en la próxima sesión.'
  }, {
    icon: <FileText className="w-6 h-6 text-brand-green" strokeWidth={1.75} data-id="element-117" />,
    title: '100% PDF — mercado argentino',
    desc: 'Diseñado para la realidad de las obras sociales, el CUD y la clínica fonoaudiológica en Argentina.'
  }];
  return <section className="bg-brand-green-soft py-16 md:py-24 px-4 md:px-6" data-id="element-118">
      <div className="max-w-3xl mx-auto" data-id="element-119">
        <FadeIn data-id="element-120">
          <p className="text-[11px] font-semibold tracking-[0.14em] uppercase text-brand-green mb-3" data-id="element-121">
            La solución
          </p>
          <h2 className="font-serif text-brand-dark text-3xl md:text-[42px] font-bold leading-[1.2] mb-5" data-id="element-122">
            Consultorio{' '}
            <em className="italic text-brand-green" data-id="element-123">Fono en Orden</em>
          </h2>
          <p className="text-brand-muted text-[16px] md:text-[17px] leading-[1.8] max-w-2xl" data-id="element-124">
            Un sistema completo de gestión clínica para fonoaudiólogas
            independientes, listo para usar desde el momento en que lo
            descargás. Sin crear nada desde cero. Sin improvisar. Sin quedarte
            hasta tarde escribiendo.
          </p>
          <div className="w-12 h-[2px] bg-brand-green mt-7 mb-10" data-id="element-125" />
        </FadeIn>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-5 md:gap-6" data-id="element-126">
          {benefits.map((b, i) => <FadeIn key={i} delay={i * 0.08} data-id="element-127">
              <div className="bg-brand-white rounded-[10px] p-7 border-t-[3px] border-brand-green h-full" data-id="element-128">
                <div className="mb-3" data-id="element-129">{b.icon}</div>
                <h3 className="text-brand-dark font-semibold text-[15px] md:text-base mb-2 leading-snug" data-id="element-130">
                  {b.title}
                </h3>
                <p className="text-brand-muted text-[14px] leading-relaxed" data-id="element-131">
                  {b.desc}
                </p>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}